import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { TopServiceModeDefaultView } from './top-service-mode-default.view';
import { TopServiceModeFutureOrderingView } from './top-service-mode-future-ordering.view';
import { ITopServiceModeViewProps, ITopServiceModeWithFutureOrderingViewProps } from './types';

/**
 * Abstraction point for top service UI/feature roll out of future ordering
 */
export const TopServiceModeView: React.FC<React.PropsWithChildren<
  ITopServiceModeViewProps | ITopServiceModeWithFutureOrderingViewProps
>> = props => {
  const enableFutureOrdering = useFlag(LaunchDarklyFlag.ENABLE_FUTURE_ORDERING);
  const ViewComponent = enableFutureOrdering
    ? TopServiceModeFutureOrderingView
    : TopServiceModeDefaultView;

  return <ViewComponent {...props} />;
};
